import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import LanguageSelector from "./LanguageSelector";
import logo from "../assets/logo.png";
import "./Header.css";

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className={`header ${isScrolled ? "scrolled" : ""}`}>
      <a href="/" className="logo">
        <img src={logo} alt="Convertrex Logo" />
      </a>

      <div className={`menu-icon ${isMenuOpen ? "active" : ""}`} onClick={toggleMenu}>
        <span></span>
        <span></span>
        <span></span>
      </div>

      <nav className={`nav-links ${isMenuOpen ? "active" : ""}`}>
        <a href="#home">{t('nav.home')}</a>
        <a href="#about">{t('nav.about')}</a>
        <a href="#services">{t('nav.services')}</a>
        <a href="#contact">{t('nav.contact')}</a>
        <div className="language-selector">
          <LanguageSelector />
        </div>
      </nav>
    </header>
  );
};

export default Header;
